import type {StyleFunctionProps} from '@chakra-ui/styled-system';
import {defineCssVars, defineStyle, defineStyleConfig} from '@chakra-ui/styled-system';
import {createAnatomy} from '@zag-js/anatomy';

export const textAnatomy = createAnatomy(`heading`, [`root`]).build();
export const vars = defineCssVars(`heading`, [`font-size`, `line-height`, `font-weight`]);

const truncate = {
  textOverflow: `ellipsis`,
  whiteSpace: `nowrap`,
  overflow: `hidden`,
};

export const headingTheme = defineStyleConfig({
  baseStyle: ({isTruncated}: StyleFunctionProps & {isTruncated?: boolean} = {} as any) => ({
    [vars[`font-weight`].variable]: `fontWeights.header.md`,
    [vars[`line-height`].variable]: `lineHeights.header.md`,
    fontFamily: `inter`,
    fontWeight: vars[`font-weight`].reference,
    lineHeight: vars[`line-height`].reference,
    ...(isTruncated && truncate),
  }),
  sizes: {
    // Clear the default values coming from Chakra
    [`xs`]: {},
    [`4xl`]: {},
    [`3xl`]: {},
    [`2xl`]: {},
    xl: {},
    lg: defineStyle({
      [`&&`]: {
        fontSize: [`header.lg`, null, `header.lg`],
      },
      lineHeight: [`header.lg`, `header.lg`, `header.lg`],
      [vars[`font-weight`].variable]: `fontWeights.header.lg`,
      fontSize: `header.lg`,
      [vars[`line-height`].variable]: `lineHeights.header.lg`,
    }),
    md: {
      [vars[`font-weight`].variable]: `fontWeights.header.md`,
      fontSize: `header.md`,
      [vars[`line-height`].variable]: `lineHeights.header.md`,
    },
    sm: {
      [vars[`font-weight`].variable]: `fontWeights.header.sm`,
      fontSize: `header.sm`,
      [vars[`line-height`].variable]: `lineHeights.header.sm`,
    },
  },
  defaultProps: {
    size: `md`,
  },
});
